import React from "react";
import "../pages/Proyect.css";
import htmlp from "../Assets/html_p.png";
import cssp from "../Assets/css_p.png";
import way from "../Assets/proyect/way.png";
import BackButton from "../componets/BackButton";



export const GreenWay = () => {
        const handleWebButtonClick = () => {
    window.location.href = "https://susanalab.github.io/GreenWay/"; // Reemplaza con la URL que quieras
  };

  const handleGitHubButtonClick = () => {
    window.location.href = "https://github.com/SusanaLab/GreenWay"; // Reemplaza con la URL de tu repositorio en GitHub
  };
  return (
    <div className="proyect-container">
      <BackButton/>
      <div className="proyect-header">
        <h1>GreenWay</h1>
     
      <div className="proyect-description">
        <p id="paragraph">
        This project stemmed from a deep interest in exploring the essential aspects of user interface (UI) and user experience (UX) design research. My goal was to immerse myself in research methodologies, prototyping, and design, and to achieve this, I employed specialized tools like Figma and FigJam.

Throughout this process, I gained a understanding of how to research, conceptualize, and craft effective design solutions. <br></br>

One of the most exciting facets was translating my design from a prototype into actual code. I utilized HTML and CSS, harnessing the capabilities of Flexbox and media queries to ensure the page was fully responsive on various devices.


        </p>
      </div>
      <div className="proyect-buttons">
         <button className="proyect-button" onClick={handleWebButtonClick}>Web</button>
      <button className="proyect-button" onClick={handleGitHubButtonClick}>GitHub</button>
      </div>
      <div className="proyect-tech">
        <p>Technologies</p>
        <img src={htmlp} alt="HTML" className="computer" />
        <img src={cssp} alt="CSS" className="computer" />
      </div> </div>

      <img id="way"
        src={way}
        alt="Learning List"
        className="learning-image"
      />
    </div>
  );
};

